<script>
  import Modal from "../../Components/Modal.svelte";
  import { inertia, useForm } from "@inertiajs/svelte";

  export let showGov2go;

  let redirecting = false;

  const form = useForm("gov2goForm", {
    email: null,
  });

  const clearError = (e) => {
    $form.clearErrors();
  };

  function submitForm() {
    $form.post(window.route("renewal.reminders.gov2go"), {
      onStart: () => {
        $form.clearErrors();
        $form.processing = true;
      },
      onError: (e) => {
        if (!e.modal) {
          showGov2go = false;
        }
      },
    });
  }

  function redirectSkip() {
    redirecting = true;
    window.location = window.route("checkout.index");
  }
</script>

<Modal
  bind:open={showGov2go}
  ignoreBackdrop={redirecting}
  dialogClasses="modal-dialog-centered modal-lg text-center"
>
  <div class="modal-body">
    <button
      type="button"
      class="btn-close float-end"
      on:click={() => (showGov2go = false)}
      disabled={$form.processing || redirecting}
    ></button>
    <h3 class="display-6">Receive Electronic Reminders Through</h3>
    <img src={`${import.meta.env.VITE_ASSET_URL}/images/g2g.svg`} alt="" />

    <div class="d-flex justify-content-center mb-4">
      <div class="input-group form-floating col-lg-6 w-75">
        <input
          type="email"
          class="form-control focus-ring"
          id="email"
          placeholder="me@example.com"
          class:is-invalid={$form.errors.modal?.email ?? false}
          on:focus={clearError}
          style="--bs-focus-ring-width: 0px"
          bind:value={$form.email}
        />
        <label for="email" class="form-label">Email Address</label>
        <button
          class="btn btn-primary rounded-end"
          type="button"
          id="button-addon2"
          disabled={$form.processing || redirecting}
          on:click={submitForm}>Sign Up</button
        >
        {#if $form.errors.modal?.email ?? false}
          <div class="invalid-feedback">
            {$form.errors.modal?.email ?? false}
          </div>
        {/if}
      </div>
    </div>
    <hr class="w-100 d-block border-secondary" />
    <a
      on:click={() => redirectSkip()}
      href="#"
      class:pe-none={$form.processing || redirecting}
      class:link-opacity-50={$form.processing || redirecting}
      class="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
      >No thanks, Continue</a
    >
  </div>
</Modal>
